// Override Settings
var bcSfSearchSettings = {
    search: {
        //suggestionMode: 'test',
        //suggestionPosition: 'left'
    }
};

BCSfFilter.prototype.afterShowSearchBoxMobile = function(searchBoxId) {
    // Hide debut's search bar on mobile, and show our search bar instead
    if (window.theme && theme.SearchDrawer && typeof theme.SearchDrawer.close == 'function') {
  		theme.SearchDrawer.close();
  	}
};

// Customize style of Suggestion box
BCSfFilter.prototype.customizeSuggestion = function(suggestionElement, searchElement, searchBoxId) {
    // Hide debut's search suggestion
  	if (jQ('.predictive-search-wrapper').length > 0){
        jQ('.predictive-search-wrapper').hide();
    }
};

function closeSuggestionMobile(searchBoxId, isCloseSearchBox) {
  /* console.log('closeSuggestionMobile'); */
  jQ(searchBoxId).autocomplete('close');
  jQ('.' + bcsffilter.class.searchSuggestion + '[data-search-box="' + searchBoxId + '"]').parent().hide();
  // Remove search box
  var isCloseSearchBox = typeof isCloseSearchBox !== 'undefined' ? isCloseSearchBox : false;
  if (isCloseSearchBox) jQ('.bc-sf-search-suggestion-mobile-top-panel,.bc-sf-search-suggestion-mobile-overlay').hide();
  // Update current term for all search boxes
  setValueAllSearchBoxes();
  // Add back tabindex=-1
  jQ('.bc-sf-search-no-tabindex').attr('tabindex', -1);
  // Return scrolling of body
  if(jQ('body').hasClass(bcsffilter.getClass('searchSuggestionMobileOpen'))){    
    jQ('body').removeClass(bcsffilter.getClass('searchSuggestionMobileOpen'));
  }
  bcsffilter.afterCloseSuggestionMobile(searchBoxId, isCloseSearchBox);
  
  // Close search theme debut
  if(jQ('.js-drawer-close').length > 1){
    jQ('.js-drawer-close').trigger('click');
  }
}

// #164867
BCSfFilter.prototype.prepareSuggestionProductPriceData = function(data) {
    /* If the multi-currency feature is enabled, update the product price */
    if (typeof bcSfFilterConfig.general.currencies != 'undefined' && bcSfFilterConfig.general.currencies.length > 1) {
        var currentCurrency = bcSfFilterConfig.general.current_currency.toLowerCase().trim();
        // function updateMultiCurrencyPrice(oldPrice, newPrice) { 
        //     if (typeof newPrice != 'undefined') { 
        //         return newPrice; 
        //     } 
        //     return oldPrice; 
        // } 
        // data.price_min = updateMultiCurrencyPrice(data.price_min, data['price_min_' + currentCurrency]);
        // data.price_max = updateMultiCurrencyPrice(data.price_max, data['price_max_' + currentCurrency]);
        // data.compare_at_price_min = updateMultiCurrencyPrice(data.compare_at_price_min, data['compare_at_price_min_' + currentCurrency]);
        // data.compare_at_price_max = updateMultiCurrencyPrice(data.compare_at_price_max, data['compare_at_price_max_' + currentCurrency]);
        var firstVariant = data['variants'][0];
        var isRoundedPrice = true;
        if (firstVariant.hasOwnProperty('fulfillment_service') && firstVariant.fulfillment_service == 'gift_card') {
            isRoundedPrice = false;
        }
      
        data.price_min = this.convertPriceBasedOnActiveCurrency(data.price_min, isRoundedPrice);
        data.price_max = this.convertPriceBasedOnActiveCurrency(data.price_max, isRoundedPrice);
        data.compare_at_price_min = this.convertPriceBasedOnActiveCurrency(data.compare_at_price_min, isRoundedPrice);
        data.compare_at_price_max = this.convertPriceBasedOnActiveCurrency(data.compare_at_price_max, isRoundedPrice);

        var activeCurrency = Shopify.currency.active.toLowerCase();
        var activeCountry = Shopify.country;
        if(((activeCountry=="GB") || (activeCountry=="JE") || (activeCountry=="IM")|| (activeCountry=="GU"))&&(activeCurrency=="gbp")) {
          //do nothing for now
        } else {
          var activePriceMin = "price_min_"+activeCurrency;
          var activePriceMax = "price_max_"+activeCurrency;
          var activeCPPriceMin = "compare_at_price_min_"+activeCurrency;
          var activeCPPriceMax = "compare_at_price_max_"+activeCurrency;
          if(data[activePriceMin]){
            //data.price_min = data[activePriceMin] * 100;
          }
          if(data[activePriceMax]){
            //data.price_max = data[activePriceMax] * 100;
          }
          if(data[activeCPPriceMin]){
            //data.compare_at_price_min = data[activeCPPriceMin] * 100;
          }
          if(data[activeCPPriceMax]){
            //data.compare_at_price_max = data[activeCPPriceMax] * 100;
          }
        }
    }
};
// End #164867